import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanCCTV = () => {
  const handleSuccess = (result) => {
    console.log('CCTV data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving CCTV data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="cctv"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanCCTV;
